import { Schema as S } from "effect";

/**
 * Get Insurer By IK Request Schema
 *
 * Request to get a specific insurer by IK number.
 *
 * @since 1.0.0
 */
export const GetInsurerByIkRequestSchema = S.Struct({
  /** Institutionskennzeichen (9-digit identifier) */
  iknr: S.String,
});

export type GetInsurerByIkRequest = S.Schema.Type<
  typeof GetInsurerByIkRequestSchema
>;
